__turbopack_context__.v({
  "endAdornment": "InscriptionActionInput-module__MoHLlW__endAdornment",
  "error": "InscriptionActionInput-module__MoHLlW__error",
  "input": "InscriptionActionInput-module__MoHLlW__input",
});
